import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { guideSteps, guideTips } from "@/mocks/siteData";

export default function WatchGuide() {
  return (
    <section id="guide" className="scroll-mt-20 border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="追更指南"
            title="五步走，把这部作品顺畅看完"
            description="不熟悉从哪开始？照着下面的顺序走一遍，基本就能理清怎么选形式、怎么看目录、怎么接着追。"
          />
        </Reveal>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
          <ol className="relative space-y-6">
            <span className="absolute bottom-3 left-[22px] top-3 w-px bg-background-300" aria-hidden="true" />
            {guideSteps.map((item, index) => (
              <li key={item.id} className="relative">
                <Reveal delay={index * 70}>
                  <div className="flex gap-4">
                    <span className="relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                      {item.step}
                    </span>
                    <div className="flex-1 rounded-lg border border-background-200 bg-background-50 p-5">
                      <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.detail}</p>
                    </div>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>

          <Reveal delay={120}>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-lightbulb-flash-line text-lg" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">追更小贴士</h3>
              <ul className="mt-4 space-y-3">
                {guideTips.map((tip) => (
                  <li key={tip} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-600">
                    <i className="ri-leaf-line mt-0.5 text-accent-600" />
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 rounded-md border border-secondary-200 bg-secondary-50 p-4">
                <p className="text-xs leading-relaxed text-secondary-900">
                  小提示：内容目录里的搜索与筛选都是在本页直接完成，输入关键词后结果会立即显示，不会跳转到其他页面。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}